export const tab = [
  { tabName: "dashboard", path: "/dashboard" },
  { tabName: "patients", path: "/patients" },
  { tabName: "schedule", path: "/scheduler" },
  { tabName: "reports", path: "/reports" },
  { tabName: "admin", path: "/admin" },
  { tabName: "profSettings", path: "/profile" },
];
export const subTab = [
  "locations",
  "users",
  "pracGroups",
  "facilities",
  "roleAccess",
  "survey",
  "orders",
  "signOrder",
  "insurances",
  "documents",
  "reports",
  "incomingsms",
  "super",
  "configuration",
];
export const priviledgesSubTab = [
  { privileges: "users", subTab: "Users" },
  { privileges: "pracGroups", subTab: "Groups" },
  { privileges: "facilities", subTab: "Facilities" },
  { privileges: "locations", subTab: "Locations" },
  { privileges: "roleAccess", subTab: "Roles" },
  { privileges: "insurances", subTab: "Insurance Carrier" },
  { privileges: "documents", subTab: "Documents" },
  { privileges: "reports", subTab: "Reports" },
  { privileges: "incomingsms", subTab: "Incoming SMS" },
  { privileges: "super", subTab: "Switch User" },
  { privileges: "configuration", subTab: "Configuration" },
];

export const adminSubPath = [
  "/user-view",
  "/location-view",
  "/insurance-view",
  "/admin",
];
export const patientsSubTab = [
  "/patients",
  "/new-survey",
  "/patient-view",
  "/new-order",
  "/stop-bang",
  "/berlin-questionaire",
  "/satisfaction-survey",
  "/quality-improvement-survey",
  "/epworth-sleepiness-scale",
  "/order-view",
  "/survey-view",
];

export const roles = {
  PHYSICIAN: "Physician",
};

export const ROLE_IDS = {
  ADMINISTRATOR: 4,
  CLINIC_EMPLOYEE: 1,
  CUSTOMER_SERVICE_REPS: 7,
  DME: 75,
  HOSPITAL_ADMINISTRATOR: 8,
  INSURANCE_DEPARTMENT: 9,
  INTERPRETING_PHYSICIAN: 6,
  LEAD_TECH: 25,
  LOGISTICS: 10,
  PHYSICIAN: 3,
  SCORING_TECH: 11,
  SLEEP_LAB_MANAGER: 76,
  SLEEP_TECH: 12,
  SLEEP_TECH_SCORING: 17,
  SLEEP_NAVIGATOR: 5,
  SUPER_ADMIN: 22,
  WAITING_ROOM: 2,
};

export const groupBasedLocationSubTab = ["Add Group", "Add New Location"];
export const facilityBasedLocationSubTab = ["Add Facility", "Add New Location"];

// actionTypes.js

export const DashboardActionTypes = {
  RESULTS_FOLLOWUP: "resultsFollowup",
  RESCHEDULE_CANCEL_STUDY: "rescheduleCancelStudy",
  REVIEW_INSURANCE_DENIAL: "reviewInsuranceDenial",
  WAITING_TO_RESCHEDULE: "waitingToReschedule",
  INTERPRETATION_REFERRED_TO_SPECIALIST: "interpretationReferredToSpecialist",
  DISCUSS_RESULTS_WITH_PATIENT: "discussResultsWithPatient",
  CONFIRM_STUDY_INFO_TX: "confirmStudyInfoTx",
  CONFIRM_STUDY_INFO: "confirmStudyInfo",
  COMPLETE_BILLING: "completeBilling",
  SCORE_STUDY: "scoreStudy",
  UPLOAD_INTERPRETATION: "uploadInterpretation",
  REVIEW_INTERPRETATION_AND_FOLLOWUP: "reviewInterpretationAndFollowup",
  REVIEW_INTERPRETATION_AND_FOLLOWUP_2: "reviewInterpretationAndFollowup2",
  READY_FOR_INTERPRETATION: "readyForInterpretation",
  READY_FOR_INTERPRETATION_2: "readyForInterpretation2",
  COMPLETE_DME_APPOINTMENT_TX: "completeDmeAppointmentTx",
  CONFIRM_SLEEP_STUDY: "confirmSleepStudy",
  GET_AUTHORIZATION: "getAuthorization",
  REQUEST_RESCHEDULE_CANCEL_STUDY: "requestRescheduleCancelStudy",
  REQUEST_RESCHEDULE_CANCEL_STUDY_TX: "requestRescheduleCancelStudyTx",
  COMPLETE_CONSENT_FORMS_TX: "completeConsentFormsTx",
  COMPLETE_CONSENT_FORMS: "completeConsentForms",
  VERIFY_INSURANCE: "verifyInsurance",
  VERIFY_INSURANCE_TX: "verifyInsuranceTx",
  COMPLETE_CANCEL_UPDATE: "completeCancelUpdate",
  SCHEDULE_TX_EDUCATION: "scheduleTxEducation",
  WAITING_TO_SCHEDULE_TX_EDUCATION: "waitingToScheduleTxEducation",
  TRANSFER_DME_ORDER: "transferDmeOrder",
  TRANSFER_ORDER: "transferOrder",
  SCHEDULE: "schedule",
  WAITING_TO_SCHEDULE: "waitingToSchedule",
  UPLOAD_COMPLIANCE_REPORT: "uploadComplianceReport",
  REVIEW_REJECT_SIGN_DME_ORDER: "reviewRejectSignDmeOrder",
  DOWNLOAD_UPLOAD_FAX: "downloadUploadFax",
  REVIEW_REJECT_SIGN: "reviewRejectSign",
  INVALID_REFERRAL_FOLLOWUP: "invalidReferralFollowup",
  VIEW_CLOSE: "viewClose",
  REVIEW_COMPLIANCE: "reviewCompliance",
  UPLOAD_F2F_EVALUATION: "uploadF2FEvaluation",
  REVIEW_COMPLIANCE_PRIVELEGE: "reviewCompliance",
  UPLOAD_F2F_EVALUATION_PRIVELEGE: "F2Fevaluation",
  RECOVER_PAP_DEVICE: "recoverPapDevice",
  RECOVER_PAP_DEVICE_PRIVILEGE: "recoverDevice",
  SLEEP_TECH_PRIVILEGE: "sleepTech",
  SCORING_PRIVILEGE: "scoring",
  INTERPRET_STUDY_PRIVILEGE: "interpretStudy",
  UPLOAD_RESULTS_PRIVILEGE: "uploadResults",
  ALL_PATIENTS_PRIVILEGE: "allPatients",
  REVIEW_FORMS_PRIVILEGE: "reviewForms",
  REVIEW_AUTH_DENIAL_ORDER_PRIVILEGE: "reviewAuthDenialOrder",
  FOLLOW_UP_PRIVILEGE: "followup",
  REFERRAL_PRIVILEGE: "referral",
  DME_REFERRAL_PRIVILEGE: "dmeReferral",
  DASHBOARD_FILTERS_KEY: "dashboard_filters",
};

export const DocumentUploadTypes = {
  EDF_STUDY: "edfStudy",
};
